<template lang="pug">
#training_events
  .main_container.container
    breadcrumb(v-bind:pageName="announcement.name")
    .course
      .ck-content(v-html="announcement.content")
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Breadcrumb from "@/components/common/Breadcrumb";
import { getAnnouncement } from "@/api/web_content";

export default {
  name: "Announcements",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      announcementList: [],
      selectIndex: 0,
      announcement_id: "",
      announcement: {},
    };
  },
  watch: {
    "$route.query.id"() {
      this.announcement_id = this.$route.query.id;
      this.getAnnouncement();
    },
  },
  created() {
    this.announcement_id = this.$route.query.id;
    this.getAnnouncement();
  },
  methods: {
    getAnnouncement() {
      getAnnouncement(this.announcement_id).then((response) => {
        this.announcement = response.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
#training_events {
  background-color: $color_bg_white;
}
.camp_name {
  color: $c-text;
  font-weight: 500;
  font-size: 20px;
  margin-top: 30px;
}

::v-deep .detail_btn {
  float: initial;
}
</style>
